import { useMutation } from "@tanstack/react-query";
import { DashboardServiceImpl } from "features/dashboard/domain/services/dashboardService";
import { VanityUrlCheckResponse } from "features/dashboard/domain/model/vanityUrlCheckResponse";

const DashboardService = new DashboardServiceImpl();

export const useCheckCustomLinkAvailability = (
  onError?: (error: Error) => void,
  onSuccess?: (data: VanityUrlCheckResponse) => void
) => {
  return useMutation({
    mutationFn: (url: string) =>
      DashboardService.checkShortUrlAvailability(url),
    onError,
    onSuccess,
  });   
};